<template>
  <div>
    <div class="noticia-not-found">
      <!-- <div class="nnf-img-text"> -->
      <img src="../../../assets/imgs/search-not-found.svg" alt="Notícia não encontrada!" />
      <p><slot /></p>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404',
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_cores.scss';

.noticia-not-found {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 600px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  & .nnf-img-text {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  & img {
    margin-top: 5%;
    opacity: 0.3;
    width: 100px;
    height: 100px;
  }
  & p {
    padding: 0 15%;
    text-align: center;
    font-family: 'VivoType';
    font-size: 1.5rem;
    color: $cor_cinza;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .noticia-not-found {
    position: relative;
    width: 80vw;
    max-width: 600px;
    margin-bottom: 10%;
  }
}
</style>
